"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.postScoreHistoryCancel = exports.postScoreHistoryAdd = void 0;
var core_1 = __importDefault(require("@/api/core"));
var postScoreHistoryAdd = function (params) {
    return core_1.default.post({ url: '/score-history/add', data: params });
};
exports.postScoreHistoryAdd = postScoreHistoryAdd;
var postScoreHistoryCancel = function (params) { return core_1.default.post({ url: '/score-history/cancel', data: params }); };
exports.postScoreHistoryCancel = postScoreHistoryCancel;
